<template>
  <div class="">
    <div v-if="!showNoCreditsStartedMessage" class="py-4 px-4">
      <img :src="dashboardMyCollegeCreditsImage" alt="img-my-college-credits" class="pb-4" />
      <div class="font-weight-bold pb-2">Nothing here yet - start today!</div>
      <div class="pt-1">Complete a course or add college credits to start seeing them stack up here.</div>
    </div>

    <div v-if="showNoCreditsStartedMessage" class="py-4 px-4">
      <div class="justify-content-space-between">
        <div>
          <div v-for="(collegeCredit, index) in collegeCreditsProgress" :key="index" class="d-flex">
            <p
              class="align-center mb-4"
              style="display: flex; font-size: 14px"
              :style="collegeCredit.status === 'completed' ? '' : 'color:#484848'"
            >
              <img
                class="mr-4"
                style="width: 24px; height: 24px"
                :src="collegeCreditsProgressImageAndText[collegeCredit.status].image"
                alt=""
              />
              {{ collegeCredit.numberOfCredits }} {{ collegeCreditsProgressImageAndText[collegeCredit.status].text }}
              <span class="ml-2">
                <v-tooltip
                  right
                  color="#484848"
                  max-width="250px"
                  @update:modelValue="
                    (val) =>
                      val
                        ? asuoDataLayerClick('accelerateDashboard', '15', {
                            text: progressTooltipMessage[collegeCredit.status].toLowerCase()
                          })
                        : asuoDataLayerClick('accelerateDashboard', '16', {
                            text: progressTooltipMessage[collegeCredit.status].toLowerCase()
                          })
                  "
                >
                  <template v-slot:activator="{ props }">
                    <div v-bind="props" style="cursor: pointer; font-size: 13px; pointer-events: auto !important">
                      <img :src="circleInfoRegularIcon" alt="icon" />
                    </div>
                  </template>
                  <span class="tooltip-text">
                    {{ progressTooltipMessage[collegeCredit.status] }}
                  </span>
                </v-tooltip>
              </span>
            </p>
          </div>
        </div>
      </div>
      <div
        v-if="showCreditsNotCompletedMessage"
        class="align-center px-6 py-2 degrees-certificate-text"
        style="font-size: 14px; color: #747474; display: flex; background-color: #f6f6f6"
      >
        <v-icon class="mr-4">mdi-information</v-icon>
        <div>
          Once you complete your first course you'll also see a summary of your completed credits and your GPA here.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { useCoursesStore } from '@/stores/courses';

// Import SVG assets
import dashboardMyCollegeCreditsImage from '@/assets/images/dashboard-my-college-credits.svg';
import circleCheckGreenIcon from '@/assets/icons/circle-check-green.svg';
import circleInfoRegularIcon from '@/assets/icons/circle-info-regular.svg';
import circleInProgressIcon from '@/assets/icons/circle-in-progress-my-college-credits.svg';
import circlePendingIcon from '@/assets/icons/circle-pending-my-college-credits.svg';

import { SessionInitializer } from '../../mixins/sessionInitializer';
import { Helper } from '../../mixins/helpers';
import { DataLayerMixin } from '../../mixins/dataLayerMixin';
import { Logger } from '../../mixins/logger';

export default defineComponent({
  mixins: [SessionInitializer, Helper, DataLayerMixin, Logger],

  data() {
    return {
      // Imported SVG assets made available to template
      dashboardMyCollegeCreditsImage,
      circleCheckGreenIcon,
      circleInfoRegularIcon,
      circleInProgressIcon,
      circlePendingIcon,

      collegeCreditsProgressImageAndText: {
        completed: { image: circleCheckGreenIcon, text: 'verified ASU credits' },
        inprogress: { image: circleInProgressIcon, text: 'credits in-progress' },
        pending: { image: circlePendingIcon, text: 'credits pending' }
      },
      progressTooltipMessage: {
        completed: 'Credits that have been completed through ASU and added to your transcript.',
        inprogress: 'Credits from ASU courses you currently have in-progress',
        pending: 'Credits that need to be added to your transcript.'
      }
    };
  },

  computed: {
    collegeCredits() {
      const coursesStore = useCoursesStore();
      return coursesStore.collegeCredits;
    },
    collegeCreditsProgress() {
      return [
        { status: 'completed', numberOfCredits: this.collegeCredits.creditsCompleted },
        { status: 'inprogress', numberOfCredits: this.collegeCredits.creditsInProgress },
        { status: 'pending', numberOfCredits: this.collegeCredits.creditsPending }
      ];
      // .filter((credit) => credit.numberOfCredits > 0); // Remove if  0 credits
    },
    showNoCreditsStartedMessage() {
      const coursesStore = useCoursesStore();
      return coursesStore.showLearnerProgress;
    },
    showCreditsNotCompletedMessage() {
      return this.collegeCredits.creditsPending + this.collegeCredits.creditsCompleted === 0;
    }
  }
});
</script>
<style lang="scss" scoped>
.justify-content-space-between {
  display: flex;
  justify-content: space-between;
}

.tooltip-text {
  font-size: 14px;
  color: white;
  text-align: left;
}
</style>
